<template>
  <div class="mainContainer">
    <div class="leftContainer">
      <div class="statisticContainer">
        <div class="statisticInnerContainer">
          <div class="countContainer">
            <div class="countNameContain">
              <img src="../../assets/level/fire.png" class="icon" />
              <p class="countName">总发布数</p>
            </div>
            <p class="countNum">{{ news_num }}</p>
          </div>
          <div class="countContainer">
            <div class="countNameContain">
              <img src="../../assets/level/fire.png" class="icon" />
              <p class="countName">总粉丝数</p>
            </div>
            <p class="countNum">{{ total_fans }}</p>
          </div>
          <div class="countContainer">
            <div class="countNameContain">
              <img src="../../assets/level/fire.png" class="icon" />
              <p class="countName">总展现数</p>
            </div>
            <p class="countNum">{{ transNum(user_watch_num) }}</p>
          </div>
          <div class="countContainer">
            <div class="countNameContain">
              <img src="../../assets/level/fire.png" class="icon" />
              <p class="countName">累计收益</p>
            </div>
            <p class="countNum">
              {{ income_amount }}<span class="yuan">元</span>
            </p>
          </div>
        </div>
      </div>
      <div class="swipe" v-if="bannerList.length">
        <el-carousel trigger="click" :interval="3000">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img
              :src="item.b_imgs"
              class="bannerImg"
              @click="bannerClick(item)"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <ScriptLibrary style="margin-top: 20px" :showAdd="false"></ScriptLibrary>
    </div>
    <div class="rightContainer">
      <div class="noticeContainer">
        <div class="labelContainer">
          <p class="label">公告</p>
          <div class="moreContainer" @click="toNotice">
            <p class="moreLabel">更多</p>
            <img src="../../assets/rightArrow.png" class="moreImg" />
          </div>
        </div>
        <ul class="noticeList">
          <li v-for="(item, index) in notices" :key="index" @click="toNotice">
            <p class="time">{{ item.ns_create_time | dateFormat }}</p>
            <p class="title">{{ item.ns_title }}</p>
          </li>
        </ul>
      </div>
      <div class="planContainer" @click="showStarSupportPlan = true">
        <img src="../../assets/index/plan.jpg" class="planThumb" />
      </div>
      <div class="videoContainer">
        <div class="labelContainer">
          <p class="label">热议话题</p>
          <div class="moreContainer" @click="changeVideo">
            <p class="moreLabel">换一换</p>
            <img src="../../assets/index/refresh.png" class="moreImg" />
          </div>
        </div>
        <ul class="videoList">
          <li
            v-for="(item, index) in videoShow"
            :key="index"
            @click="videoClick(item)"
          >
            <p>{{ item.title }}</p>
            <img src="../../assets/topicArrow.png" class="topicArrow" />
          </li>
        </ul>
      </div>
    </div>

    <el-dialog
      :visible.sync="showStarSupportPlan"
      top="5vh"
      :center="true"
      width="fit-content"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <iframe
        :src="starSupportPlanSrc"
        class="starSupportPlan"
        style="height: 78vh; width: 500px"
      />
    </el-dialog>
  </div>
</template>

<script>
import { NEWS_HOST, SWNEWS_HOST, BI_HOST } from "../../constants/apiHosts";
import config from "../../config/index";
import dbRequest from "../../plugin/request-bd";
import ScriptLibrary from "../scriptLibrary/script/index.vue";

export default {
  data() {
    return {
      news_num: 0,
      total_fans: 0,
      user_watch_num: 0,
      income_amount: 0,
      notices: [],
      bannerList: [],
      videoShow: [],
      videos: [],
      videoIndex: 0,
      videoAll: 1,
      onePageCount: 7,
      showStarSupportPlan: false,
      starSupportPlanSrc: "",
    };
  },
  filters: {
    dateFormat: function (date) {
      date = date.split(" ")[0];
      let array = date.split("-");
      return array[1] + "-" + array[2];
    },
  },
  components: {
    ScriptLibrary,
  },
  created() {
    this.getStatistic();
    this.getStatisticPub();
    this.getNotice();
    this.getBanner();
    this.getVideo();

    this.starSupportPlanSrc = `https://m.${
      location.href.indexOf("dingxinwen.com") >= 0 ||
      location.href.indexOf("topnews.cn") >= 0
        ? "topnews.cn"
        : "dingnews.net"
    }/a/pages/starSupportPlan/ordinary/index?isCreator=1&token=${localStorage.getItem(
      "token"
    )}`;
    window.closePlan = () => {
      this.showStarSupportPlan = false;
    };

    this.trackFn();
  },
  mounted() {},
  methods: {
    trackFn() {
      dbRequest({
        url: `${BI_HOST}/bd`,
        method: "POST",
        params: {
          b_type: "创作中台首页",
        },
      }).then((res) => {
        if (res.data.code == 200) {
        } else {
          //this.$message.error(res.data.msg);
        }
      });
    },
    getNotice() {
      this.$axios
        .get(`${NEWS_HOST}/api/notice/search?request_type=2&page=1&size=4`)
        .then((res) => {
          if (res.data.code == 0) {
            this.notices = res.data.data.returnData;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toNotice() {
      this.$router.push({
        path: "/notice",
        query: {
          isNotice: 1,
        },
      });
    },
    getStatistic() {
      this.$axios.get(`${NEWS_HOST}/api/user/creatorDataCenter`).then((res) => {
        if (res.data.code == 0) {
          this.income_amount = this.toThousands(res.data.data.income_amount);
          this.user_watch_num = res.data.data.user_watch_num;
        }
      });
    },
    getStatisticPub() {
      this.$axios.get(`${NEWS_HOST}/api/user/userNumCount`).then((res) => {
        if (res.data.code == 0) {
          this.news_num = this.toThousands(res.data.data.news_num);
          this.total_fans = this.toThousands(res.data.data.fans_num);
        }
      });
    },
    getBanner() {
      this.$axios.get(`${NEWS_HOST}/api/user/creatorBanner`).then((res) => {
        if (res.data.code == 0) {
          this.bannerList = res.data.data;
        }
      });
    },
    getVideo() {
      this.$axios.get(`${SWNEWS_HOST}/api/hottopic/search`).then((res) => {
        if (res.data.code == 0) {
          this.videoAll = Math.trunc(res.data.data.length / this.onePageCount);
          this.videos = res.data.data;
          this.changeVideo();
        }
      });
    },
    changeVideo() {
      this.videoShow = this.videos.slice(
        this.videoIndex * this.onePageCount,
        this.videoIndex * this.onePageCount + this.onePageCount
      );
      this.videoIndex++;
      if (this.videoIndex == this.videoAll) {
        this.videoIndex = 0;
      }
    },
    videoClick(item) {
      let routeData = this.$router.resolve({
        path: `/theme?id=${item.id}`,
      });
      window.open(routeData.href, "_blank");
    },
    bannerClick(item) {
      switch (item.b_type) {
        case 1:
          // 稿件
          window.open(`https://www.topnews.cn/news/${item.b_use_id}`);
          break;
        case 2:
          // 专题
          window.open(`https://m.topnews.cn/topic/${item.b_use_id}#/`);
          break;
        case 3:
          // 直播
          window.open(`https://m.topnews.cn/live/${item.b_use_id}`);
          break;
        default:
          if (item.b_url) {
            window.open(item.b_url);
          }
      }
    },
    toThousands(str) {
      var newStr = "";
      var count = 0;
      str = str + "";
      // 当数字是整数
      if (str.indexOf(".") == -1) {
        for (var i = str.length - 1; i >= 0; i--) {
          if (count % 3 == 0 && count != 0) {
            newStr = str.charAt(i) + "," + newStr;
          } else {
            newStr = str.charAt(i) + newStr;
          }
          count++;
        }
        str = newStr; //自动补小数点后两位
        return str;
      }
      // 当数字带有小数
      else {
        for (var i = str.indexOf(".") - 1; i >= 0; i--) {
          if (count % 3 == 0 && count != 0) {
            newStr = str.charAt(i) + "," + newStr;
          } else {
            newStr = str.charAt(i) + newStr; //逐个字符相接起来
          }
          count++;
        }
        str = newStr + (str + "00").substr((str + "00").indexOf("."), 3);
        return str;
      }
    },
    timeLeftFn(endTime) {
      return Math.trunc((endTime - new Date().getTime()) / 86400000) + 1;
    },
    planClose(done) {
      this.starSupportPlanSrc = "";
      done();
    },
    transNum(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + "万";
      } else {
        return this.toThousands(num);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContainer {
  display: flex;
  justify-content: space-between;

  .leftContainer {
    flex: 1;
    margin-right: 20px;

    .statisticContainer {
      background: #ffffff;
      border-radius: 8px;
      min-width: 750px;
      padding: 0 0 25px 0;

      .statisticInnerContainer {
        display: flex;
        padding-top: 24px;
      }

      .countContainer {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .countNameContain {
          display: flex;
          justify-content: center;

          .icon {
            height: 18px;
            margin-right: 2px;
          }
        }

        .countName {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          margin-bottom: 3px;
        }

        .countNum {
          font-size: 32px;
          font-family: DINPro-Bold, DINPro;
          font-weight: bold;
          color: #333333;
          line-height: 41px;

          .yuan {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
          }
        }
      }
    }

    .swipe {
      width: 100%;
      background: #ffffff;
      margin-top: 21px;
      padding-bottom: 21%;
      position: relative;
      border-radius: 8px;
      overflow: hidden;

      .el-carousel {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        cursor: pointer;

        .bannerImg {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /deep/.el-carousel__container {
          height: 100%;
        }

        /deep/.el-carousel__indicators {
          transform: none;
          right: 20px;
          left: auto;
          bottom: 8px;

          .el-carousel__indicator {
            padding: 0;

            .el-carousel__button {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              margin-left: 12px;
            }
          }
        }
      }
    }

    .activityContainer {
      background: #ffffff;
      border-radius: 8px;
      margin-top: 20px;
      padding: 24px;

      .label {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
        letter-spacing: 1px;
        padding-bottom: 12px;
      }

      .activityListContainer {
        display: flex;
        flex-wrap: wrap;

        .activityList {
          width: calc((100% - 24px) / 3);
          border-radius: 6px;
          background: rgba(255, 255, 255, 1);
          margin: 12px 12px 0 0;
          padding: 20px;
          box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.14);

          .coverImageContainer {
            width: 100%;
            padding-bottom: 48.76%;
            position: relative;
          }

          .coverImage {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            object-fit: cover;
            border-radius: 6px;
          }

          .titleContainer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 12px;

            .activityTitle {
              width: calc(100% - 22px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              line-height: 22px;
              color: rgba(51, 51, 51, 1);
              font-size: 16px;
              font-weight: 500;
              font-family: "PingFang SC";
            }
          }

          .timeContainer {
            display: flex;
            margin-top: 6px;
            line-height: 20px;
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
            font-weight: 400;
            font-family: "PingFang SC";

            .time {
              color: #ea0e0e;
            }
          }
        }

        .activityList:nth-child(3n) {
          margin-right: 0;
        }

        .activityList:hover {
          box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.14);
        }
      }
    }
  }

  .rightContainer {
    width: 360px;
    flex-shrink: 0;

    .noticeContainer {
      background: #ffffff;
      border-radius: 8px;
      padding: 24px 24px 4px 24px;

      .labelContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .label {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
        }

        .moreContainer {
          display: flex;
          align-items: center;
          cursor: pointer;

          .moreLabel {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
          }

          .moreImg {
            height: 18px;
          }
        }
      }

      .noticeList {
        margin-top: 24px;

        li {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          margin: 0 0 20px 0;
          display: flex;
          cursor: pointer;

          .time {
            width: 50px;
          }

          .title {
            width: 262px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .planContainer {
      background: #ffffff;
      margin-top: 20px;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;

      .planThumb {
        width: 100%;
        display: block;
      }
    }

    .videoContainer {
      background: #ffffff;
      border-radius: 8px;
      padding: 24px 24px 18px 24px;
      margin-top: 20px;

      .labelContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .label {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
        }

        .moreContainer {
          display: flex;
          align-items: center;
          cursor: pointer;

          .moreLabel {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin-right: 4px;
          }

          .moreImg {
            height: 18px;
          }
        }
      }

      .videoList {
        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #333333;
          font-size: 16px;
          margin: 24px 0;
          line-height: 24px;
          cursor: pointer;

          .topicArrow {
            height: 16px;
          }
        }
      }
    }
  }
}
</style>
